// extracted by mini-css-extract-plugin
export default {"emptyStateContainer":"styles_emptyStateContainer__9i6uO","emptyStateText":"styles_emptyStateText__QDRjF"};